/**
 * 企業中心 PC 首頁 — English (nested for t('corporateCenter.indexPc.…'))
 */
export default {
	banner: {
		titleLine1: "Empower Institutions with Traffic,",
		titleLine2: "Ensure Compliance, Boost Efficiency & Expand Customer Base",
		body: "SeerQ Group is headquartered in Hong Kong, with branches across Singapore, Malaysia, and Taiwan. As a world-leading digital marketplace for life guidance, we use AI and digital technology to connect users with global professional mentors, offering private, secure support. With ratings, escrow, and standardized services, we protect both parties and empower users to grow. Our vision: See Beyond, for an easier life.",
		joinCta: "Join now",
		contactCta: "Contact us",
		heroImageAlt: "Seer corporate services overview",
		contactCoopModal: {
			title: "Other business partnerships",
			body: "We focus on the “Global mentors + privacy protection + digital services” space with strong growth potential. We welcome partnerships.",
			cta: "Contact us ({email}) →",
			closeAria: "Close",
		},
	},
	section1: {
		sectionTitle: "Safeguard Centuries of Heritage, Meet the Challenges of a New Generation",
		challengeColumnTitle: "Key challenges",
		solutionColumnTitle: "All-in-One Digital Solution",
		challenge: [
			{
				title: "Younger Generation Gap",
				desc: "Modern life is fast-paced, creating detachment and distance from traditional beliefs.",
			},
			{
				title: "Concerns Over Remote Services",
				desc: "After online payment, users cannot witness the ritual in person, leaving doubts about whether it was properly performed.",
			},
			{
				title: "Overwhelming Administrative Work",
				desc: "List registration, account reconciliation, receipt issuance and other tasks consume significant manpower and time.",
			},
		],
		solution: [
			{
				title: "Guided Precisely: Technology as an Extension of the Divine",
				desc: "Through mobile-based guidance, we connect the younger generation and lead the destined to temples for prayer.",
			},
			{
				title: "Divine Presence Made Visible: Innovating Tools, Not Traditions.",
				desc: "The entire ritual is recorded and sent to devotees with one tap, making blessings tangible and prayers answered.",
			},
			{
				title: "Continuous Blessings: Your Dedicated Digital Secretary",
				desc: "Automatic reminders for prayers aligned with solar terms, unbounded by distance, keeping divine blessings ever-present and incense everlasting.",
			},
		],
	},
	section2: {
		mapImageAlt: "World distribution map",
		sectionTitle: "Why  SeerQ?",
		sectionDesc:
			"SeerQ is headquartered in Hong Kong, with a presence in Singapore, Malaysia, and Taiwan.",
		marker: [
			{ label: "North America" },
			{ label: "Other regions" },
			{ label: "Southeast Asia" },
			{ label: "Japan & Korea" },
		],
		metric: [
			{ text: "Monthly Active App Users: " },
			{ text: "Monthly Active Users:" },
			{ text: "Facebook Followers: " },
			{ text: "YouTube Unique Viewers: " },
			{ text: "Global KOL Partners: " },
		],
	},
	section3: {
		sectionTitle: "Partnership value",
		rowLabelTop: "Actual Results",
		rowLabelBottom: "Long-term value",
		top: [
			{
				title: "Digital Transformation Opportunities",
				desc: "Institutions can upgrade their online presence with SeerQ's AI and digital capabilities, empowered by SaaS tools and targeted advertising. Seize the benefits of digital transformation and deliver premium services to users.",
			},
			{
				title: "Expanded Business Channels",
				desc: "We integrate online and offline scenarios, delivering tailored solutions for temples, churches, meditation, healing, and counseling institutions. We help attract steady clients, break service boundaries, drive growth through precise user reach, and scale your business effectively.",
			},
			{
				title: "Enhance Institutional Influence",
				desc: "Leverage our platform's traffic and user base to boost your brand exposure and credibility. Standardize processes, mitigate risks, and strengthen professional competitiveness. Achieve mutual empowerment, win-win cooperation, build a sustainable ecosystem, and solidify your leading position in the industry.",
			},
		],
		bottom: [
			{
				title: "Intelligent Plain Language",
				desc: "We translate profound traditional wisdom into clear, modern guidance that young people can easily understand and embrace.",
			},
			{
				title: "Boutique Service Experience",
				desc: "Elevate temple services into personalized spiritual navigation, attracting diverse groups of young professionals.",
			},
			{
				title: "Professional Brand Image",
				desc: "Abandon unprofessional stereotypes, establish an authoritative and professional image, and fully enhance the temple’s social standing and public credibility.",
			},
		],
	},
	join: {
		sectionTitle: "Onboarding Process",
		centerImageAlt: "Seer",
		step1: {
			title: "Onboarding Initiation",
			desc: "Institutions register on the official SeerQ website to start the onboarding process.",
		},
		step2: {
			title: "Complete Information",
			desc: "Fill in institution details, customize your display page, list services, and upload qualifications.",
		},
		step3: {
			title: "Platform Review",
			desc: "The platform conducts dual reviews of qualifications and content for the onboarding application.",
		},
		step4: {
			title: "Onboarding Successful",
			desc: "Once approved, the institution will receive a notification, and its information and services will be launched simultaneously on the SeerQ App.",
		},
	},
	section4: {
		title: "Promotion & Precise User Reach",
		desc: "After the institution is approved, users can browse its information and purchase services in the SeerQ App. Institutions can connect with users through the App's free consultation feature and complete service delivery.",
		imageAlt: "Promotion and user reach showcase",
	},
	section5: {
		title: "Contact Us",
		desc: "During the institution's onboarding process, our dedicated customer service team will provide professional solutions and full support for any issues encountered.",
		btn: "Contact Dedicated Support Now",
	},
	loginModal: {
		tabEmail: "Email",
		tabPhone: "Mobile",
		mPrivacy: "We protect your privacy. Others will not see this information.",
		mPhoneStepTitle: "Enter your mobile number",
		mEmailStepTitle: "Enter your email",
		mAreaCodeLabel: "Code",
		mSwitchToEmail: "Use email to sign in >",
		mSwitchToPhone: "Use mobile number to sign in >",
		mNext: "Next",
		mInvalidEmail: "Please enter a valid email address",
		mVerificationTitle: "Enter verification code",
		mVerificationSentPrefix: "We sent a verification code to",
		mResendWait: "Resend code ({n}s)",
		mResendLink: "Resend code",
		mToastCodeSent: "Verification code sent",
		mToastCodeSendFail: "Failed to send the code. Please try again.",
		mToastLoginCodeWrong: "Sign-in failed. Please check your verification code.",
		mToastSelectAreaCode: "Please select a country/region code",
		mToastCompleteCaptcha: "Please complete the security check",
		mToastCaptchaFail: "Verification failed. Please try again.",
		mToastCaptchaExpired: "Verification expired. Please verify again.",
		mToastCaptchaUnsupported: "This browser is not supported. Please try another browser.",
		mPhonePlaceholder: "Enter your mobile number",
		mEmailPlaceholder: "Enter your email",
		mCodePlaceholderPhone: "Enter the SMS code",
		mCodePlaceholderEmail: "Enter the email verification code",
		mGetCode: "Get code",
		mLogin: "Sign in",
		mBack: "Go back",
		bindTitle: "Enter your email to bind your account",
		bindDesc: "If you have any questions, please contact customer support.",
		bindBtn: "Bind",
		kefu: "Customer support",
		loginSuccess: "Signed in successfully",
	},
};
